"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _draftjsToHtml = _interopRequireDefault(require("draftjs-to-html"));

var _htmlToDraftjs = _interopRequireDefault(require("html-to-draftjs"));

var _draftJs = require("draft-js");

var _LinkSelect = _interopRequireDefault(require("../draftjs/LinkSelect"));

var _theme = require("../../theme");

var _templateObject, _templateObject2;

var Editor = function Editor() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};

var Wysiwyg = function Wysiwyg(props) {
  var index = props.index,
      value = props.value,
      onChange = props.onChange;

  var _ref = (0, _react.useState)(_draftJs.EditorState.createEmpty()),
      _ref2 = _slicedToArray(_ref, 2),
      editorState = _ref2[0],
      setEditorState = _ref2[1];

  var _ref3 = (0, _react.useState)(null),
      _ref4 = _slicedToArray(_ref3, 2),
      editor = _ref4[0],
      setEditor = _ref4[1];

  var editorRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    // We have to lazy load the component like this because SSR doesn't work otherwise
    Editor = require('react-draft-wysiwyg').Editor;
    setEditor(true);
  }, []); // Convert html value to editor state on initial load
  // Afterward, we gonna use local state and send the converted html back to the store

  (0, _react.useEffect)(function () {
    if (value) {
      var blocksFromHTML = (0, _htmlToDraftjs.default)(value);

      var contentState = _draftJs.ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);

      var _editorState = _draftJs.EditorState.createWithContent(contentState);

      setEditorState(_editorState);
    }
  }, [index]);

  var handleChange = function handleChange(editorState) {
    setEditorState(editorState); // Convert editor state to html and send to store

    var contentState = editorState.getCurrentContent();
    var rawState = (0, _draftJs.convertToRaw)(contentState);
    var html = (0, _draftjsToHtml.default)(rawState);
    onChange(html);
  };

  return /*#__PURE__*/_react.default.createElement(EditorContainer, null, editor && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Editor, {
    toolbarCustomButtons: [/*#__PURE__*/_react.default.createElement(_LinkSelect.default, null)],
    editorState: editorState,
    onEditorStateChange: handleChange,
    placeholder: "Write something...",
    ref: editorRef,
    toolbar: {
      options: ['inline', 'blockType', 'textAlign', 'list'],
      inline: {
        options: ['bold', 'italic']
      },
      blockType: {
        inDropdown: true
      },
      textAlign: {
        inDropdown: true
      },
      list: {
        inDropdown: true
      }
    },
    stripPastedStyles: true
  })));
};

var icon = (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  height: 30px;\n  margin: 0 1px;\n  background: #fff;\n  border: none;\n  box-shadow: none;\n\n  &:hover {\n    background: ", ";\n    box-shadow: none;\n  }\n"])), _theme.colors.secondaryContrast);

var EditorContainer = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n\n  .rdw-editor-toolbar {\n    position: relative;\n    z-index: 2;\n    padding: 0;\n    margin: 0 0 4px;\n    border: none;\n    background: transparent;\n    transform: translateX(-1px);\n\n    a {\n      pointer-events: all !important;\n      color: rgba(0, 0, 0, 0.85);\n    }\n  }\n\n  .rdw-editor-main {\n    min-height: 100px;\n    background: #fff;\n    font-size: 13px;\n    line-height: 18px;\n  }\n\n  .rdw-dropdown-carettoopen,\n  .rdw-dropdown-carettoclose,\n  .rdw-link-decorator-icon {\n    display: none;\n  }\n\n  .rdw-dropdown-optionwrapper {\n    overflow: auto;\n  }\n\n  .rdw-option-wrapper,\n  .rdw-dropdown-wrapper {\n    ", "\n  }\n\n  .rdw-option-wrapper,\n  .rdw-text-align-dropdown,\n  .rdw-list-dropdown {\n    width: 30px;\n  }\n\n  .rdw-option-active {\n    background: ", ";\n  }\n\n  .rdw-block-dropdown {\n    width: auto;\n    padding: 0 4px;\n  }\n\n  .public-DraftStyleDefault-block {\n    margin-top: 12px;\n    margin-bottom: 12px;\n  }\n\n  .public-DraftStyleDefault-listLTR {\n    .public-DraftStyleDefault-block {\n      margin-top: 5px;\n      margin-bottom: 5px;\n    }\n  }\n\n  pre {\n    margin: 0;\n\n    .public-DraftStyleDefault-block {\n      margin-top: 0;\n      margin-bottom: 0;\n    }\n  }\n\n  h1 {\n    font-size: 22px;\n    font-weight: bold;\n    line-height: 1.2;\n    margin-bottom: 12px;\n  }\n\n  h2 {\n    font-size: 20px;\n    font-weight: bold;\n    line-height: 1.2;\n    margin-bottom: 10px;\n  }\n\n  h3 {\n    font-size: 18px;\n    font-weight: bold;\n    line-height: 1.2;\n    margin-bottom: 8px;\n  }\n\n  h4 {\n    font-size: 16px;\n    font-weight: bold;\n    line-height: 1.2;\n    margin-bottom: 6px;\n  }\n\n  h5 {\n    font-size: 14px;\n    font-weight: bold;\n    line-height: 1.2;\n    margin-bottom: 4px;\n  }\n\n  h6 {\n    font-size: 12px;\n    font-weight: bold;\n    line-height: 1.2;\n    margin-bottom: 4px;\n  }\n\n  a {\n    text-decoration: underline;\n    color: ", ";\n  }\n"])), icon, _theme.colors.tertiary, _theme.colors.primary);

var _default = Wysiwyg;
exports.default = _default;